import React from 'react';
import { IconButton, Tooltip } from '@mui/material';

// Ação de linha de grade/lista: ícone com tooltip (o <span> mantém o tooltip quando desabilitado)
export function RowAction({ title, onClick, children, color, disabled }: {
    title: string;
    onClick: () => void;
    children: React.ReactNode;
    color?: 'default' | 'primary' | 'error' | 'warning' | 'success';
    disabled?: boolean;
}) {
    return (
        <Tooltip title={title}>
            <span>
                <IconButton size="small" color={color} aria-label={title} onClick={onClick} disabled={disabled}>
                    {children}
                </IconButton>
            </span>
        </Tooltip>
    );
}
